import { useLayoutEffect, useRef } from "react";

export function useBlockOfficeAccentBorder(officeColor: string | undefined): React.RefObject<HTMLButtonElement | HTMLDivElement | null> {
	const rootRef = useRef<HTMLButtonElement | HTMLDivElement | null>(null);

	useLayoutEffect(() => {
		const el = rootRef.current;
		if (!el) return;
		if (officeColor) {
			el.style.setProperty("--block-office-accent", officeColor);
			el.setAttribute("data-office-border", "true");
		} else {
			el.style.removeProperty("--block-office-accent");
			el.removeAttribute("data-office-border");
		}
	}, [officeColor]);

	return rootRef;
}
